import { Plugins } from "@capacitor/core";
import { isNativeIosPlatform } from "./deviceInfo";

export function isNativeIosPhotoPickerAvailable() {
  return (
    isNativeIosPlatform() &&
    Plugins.MCSPhotoPicker != null &&
    typeof Plugins.MCSPhotoPicker.pickPhoto === "function"
  );
}

export async function pickNativeIosPhoto() {
  if (!isNativeIosPhotoPickerAvailable()) {
    throw new Error(
      "The iOS photo picker is unavailable. Please update the MyAccount app and try again."
    );
  }

  const result = await Plugins.MCSPhotoPicker.pickPhoto();
  if (result.cancelled) {
    return null;
  }

  if (typeof result.base64 !== "string" || result.base64.length === 0) {
    throw new Error("The selected image could not be prepared for upload.");
  }

  const binary = window.atob(result.base64);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }

  return new File([bytes], result.fileName || "photo.jpg", {
    type: result.mimeType || "image/jpeg",
  });
}
